import Vue from 'vue'
import VueSlickCarousel from 'vue-slick-carousel'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import axios from 'axios'
import VueCalendar from 'v-calendar'
import moment from 'moment'
import 'moment/locale/ru'
import TweenLite from 'gsap'
import ClickOutside from 'vue-click-outside'
import VueInputmask from 'vue-inputmask'
import Vuelidate from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

const MOMENT_DATE_FORMAT = 'YYYY-MM-DD'
const DELIVERY_TYPE_PICKUP = 3
const DELIVERY_TYPE_DELIVERY = 2

//исключен ID=9 как онлайн оплата на руднева
const ARR_ONLINE_PAMENTS_ID = ['6']

moment.locale('ru');
(function ($) {
  'use strict'
  $(
    function () {
      if ($('#ordersHistoryVue').length) {
        initHistory()
      }

      function initHistory () {
        Vue.use(VueCalendar)
        var ordersHistory = new Vue({
          el: '#ordersHistoryVue',
          data: {
            calendar: null
          },
          watch: {
            calendar(value) {
              let m_start = moment(value.start)
              let m_end = moment(value.end)
              if (m_start.isValid() && m_end.isValid()) {
                let date_from = m_start.format('DD.MM.YYYY')
                let date_to = m_end.format('DD.MM.YYYY')
                location.href = '/personal/orders/?date_from=' + date_from + '&date_to=' + date_to
              }
            }
          }
        });
      }

      if ($('#orderCartCalendarVue0').length) {
        let date = $('#orderCartCalendarVue0').data('date');
        initCartCalendar(0, date);
      }

      function initCartCalendar(id, date) {
        Vue.use(VueCalendar);
        var collOrderCart = new Vue({
          el: '#orderCartCalendarVue' + id,
          data: {
            calendar: date,
            min_date: new Date()
          },
          methods: {
            openCalendar(toggle) {
              toggle({ ref: toggle });
            }
          },
          watch: {
            calendar(value) {
              let new_date = moment(value);
              if (new_date.isValid()) {
                let date_from = date;
                let date_to = new_date.format(MOMENT_DATE_FORMAT);
                cartTransfer(date_from, date_to);
              }
            }
          }
        });
      }

      function cartTransfer(date_from, date_to) {
        let folder = '/local/components/lobsterlab/sale.groups/templates/.default';
        let ajax = folder + '/ajax/';
        let task = 'transfer';

        let url = ajax + task + '.php';
        let data = {};

        if (date_from) data.date_from = date_from;
        if (date_to) data.date_to = date_to;
        if (folder) data.folder = folder;

        console.log(data)

        $.ajax({
          url: url,
          type: 'post',
          data: data,
          dataType: 'json',
          success: function(res) {
            if (res.success) {
              $.ajax({
                url: res.success,
                type: 'post',
                dataType: 'html',
                success: function(html) {
                  $('.js-cart-container').html(html);
                  let date = $('#orderCartCalendarVue0').data('date');
                  initCartCalendar(0, date);
                }
              });
            } else {
              console.log(res.error);
            }
          }
        });
      }

      $(document).on('click', '.js-basket-menu-day', function() {
        let id = $(this).data('id');
        let date = $(this).data('date');
        initCartCalendar(id, date);
      });

      $(document).on('click', '.js-quantity-minus', function() {
        var product_id = $(this).parent().find('.js-quantity').data('product-id');
        var quantity = $(this).parent().find('.js-quantity').val();
        quantity = Number.parseInt(quantity) - 1;
        cartAction(product_id, quantity);
        return false;
      });

      $(document).on('change', '.js-quantity', function() {
        var product_id = $(this).data('product-id');
        var quantity = $(this).val();
        cartAction(product_id, quantity);
        return false;
      });

      $(document).on('click', '.js-quantity-plus', function() {
        var product_id = $(this).parent().find('.js-quantity').data('product-id');
        var quantity = $(this).parent().find('.js-quantity').val();
        quantity = Number.parseInt(quantity) + 1;
        cartAction(product_id, quantity);
        return false;
      });

      $(document).on('click', '.js-cart-action', function() {
        let product_id = $(this).data('product-id');
        let quantity = $(this).data('quantity');
        cartAction(product_id, quantity);
        return false;
      });

      function cartAction(product_id, quantity) {
        let folder = '/local/components/lobsterlab/sale.groups/templates/.default';
        let ajax = folder + '/ajax/';
        let task = 'cart-action';

        let url = ajax + task + '.php';
        let data = {};

        if (product_id) data.product_id = product_id;
        if (quantity) data.quantity = quantity;
        if (folder) data.folder = folder;

        $.ajax({
          url: url,
          type: 'post',
          data: data,
          dataType: 'json',
          success: function(res) {
            if (res.success) {
              $.ajax({
                url: res.success,
                type: 'post',
                dataType: 'html',
                success: function(html) {
                  $('.js-cart-container').html(html);
                  initCartCalendar();
                }
              });
            } else {
              console.log(res.error);
            }
          }
        });
      }

      if ($('#scheduleCartVue').length) {
        initCart()
        $(document).on(
          'gesturestart', '[data-entity="no-gesturestart"]', (e) => {
            e.preventDefault()
          }
        )
      }

      function initCart () {
        Vue.directive('map', {
          inserted: function (el, data) {
            let loc = data.value['LOCATION']
            if (!loc['x'] || !loc['y'] || el.style.display === 'none') {
              el.style.display = 'none'
              return
            }
            let center = [loc['y'], loc['x']]
            let option = {
              preset: 'twirl#lightblueStretchyIcon',
              draggable: true,
              zIndex: 10000,
              zIndexActive: 10000,
              zIndexHover: 10000
            }

            try {
              ymaps.ready(() => {
                let map = new ymaps.Map(
                  el, {
                    center: center,
                    zoom: 16,
                    controls: ['fullscreenControl'],
                  }
                )
                map.controls.remove('geolocationControl')
                map.controls.remove('searchControl')
                map.controls.remove('trafficControl')
                map.controls.remove('typeSelector')
                map.controls.remove('fullscreenControl')
                map.controls.remove('rulerControl')
                map.behaviors.disable(['scrollZoom', 'drag'])
                let myCollection = new ymaps.GeoObjectCollection()
                myCollection.removeAll()
                if (option) {
                  let mark = new ymaps.Placemark(center, {}, option)
                  map.geoObjects.add(mark)
                }
              })

            } catch (e) {
              console.log(e)
            }
          }
        })

        Vue.use(Autocomplete)
        Vue.use(VueCalendar)
        Vue.use(VueInputmask.default)
        Vue.use(Vuelidate)
        const daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
        window.scheduleCart = new Vue({
            el: '#scheduleCartVue',
            components: { 'vueslickcarousel': VueSlickCarousel, Autocomplete, VueCalendar },
            data: {
              /** Настройки слайдера календаря в расписании  */
              settings: {
                'dots': false,
                'edgeFriction': 0.35,
                'infinite': true,
                'speed': 500,
                'slidesToShow': 7,
                'slidesToScroll': 7
              },

              panelPaymentOpen: false,
              panelChangesOpen: false,
              panelCutleryOpen: false,

              /** Флаг первичной отгрузки первого шага - нужен для использования-неиспользование первичной проверки*/
              semaphoreFirstEntry: true,
              semaphoreCanCheckOut: false,
              semaphorePriceWarning: false,
              semaphoreOrderSended: false,
              loader: false,
              /** Массив дней из календаря (ключ-дата формате Y-m-d)*/
              days: window.calendarData,
              /** Массив корзин по дню (ключ-дата формате Y-m-d) */
              carts: window.cartData,
              /** Сумма по дням (ключ-дата формате Y-m-d)  */
              total: window.cartTotal,
              /** Флаг отображения календаря  */
              calendarOpened: true,
              /** Текущая отображаемая дата в формате Y-m-d  */
              showingDate: null,
              /** Флаг мобилки  */
              isMobile: false,
              /** Остаток депозита текущего дня */
              currentDateDeposit: false,
              /** кеш склонений  */
              decCache: [],
              /**  Склоненное кол-во дней  */
              daysCountPlural: null,
              /** Массив допустимых значений времени доставки в завивимости от самовывоза/доставки/даты*/
              deliveryTimeList: window.deliveryTime,
              /** Массив адресов доставок  (ключ-дата формате Y-m-d)*/
              deliveryLocation: window.deliveryLocation,
              /**  Массив адресов пользователя из профиля */
              profileAddress: window.profileAddress,
              /**Служебное - буфер выбранного адреса из профиля */
              profileAddressSelected: [],
              /**  Легаси */
              deliveryErrors: [],
              /** Доступные даты для переноса корзины */
              availableTransferDates: window.availableTransferDates,
              /**  Массив адресов пользователя из профиля */
              deliveryTimeSelected: window.deliveryTimeSelected,
              /**  Служебное - выбранный филиал самовывоза */
              pickupBranchSelected: [],
              /**  Список филиалов самовывоза */
              pickUpBranches: window.pickUpBranches,
              /**  Показать шаг с первичным вводом адреса*/
              showPanelAddress: true,
              /** Показать шаг с раписанием  */
              showPanelSchedule: false,
              /** Показать шаг с оформлением заказа  */
              showPanelCheckout: false,
              /**  Показать модальное окно с выбором времени доставки */
              showTimeModal: false,
              /** Показать  модальное окно с вводом адреса  */
              showAddressModal: false,
              /** Показать модальное окно с временем работы филиала */
              showWorkingTimeAttentionModal:false,
              /** Показать панельку с выбором филиала самовывоза  */
              showPickUpPane: false,
              /** Открыть контейнер с выбором филиалов  */
              showBranchSelectContainer: false,
              /** Показать модальное окно стоп-листов  */
              showStopListModal: false,
              /** Плказать панель с выбором времени для первого шага */
              showDeliveryTimeContainer: false,
              /** Плказать панель с выбором даты для первого шага */
              showDeliveryDateContainer: false,
              /**  Показать модальное окно стоимости доставки */
              showDeliveryPrice: false,
              /** Показать модальное окно о невозможности доставки для компании */
              showCompanyDayDisabled: false,
              /** Показать модальное окно о увеличенном спросе на данном филиале  */
              showDeliveryBusy: false,
              /**  Показать контейнер с выбром адресов из профиля пользователя */
              showProfileContainer: false,
              /** Показать уведомление о переносе корзины на другой день  */
              showCartTransfer: false,
              //show flags end
              /**  Флаг вывода первичного ввода улицы и дома */
              tDeliveryEditNow: false,
              /**  Буфер поля Улица */
              bufferStreet: null,
              /**  Буфер поля Дом*/
              bufferHouse: null,
              /**  Буфер поля Корпус */
              bufferHousing: null,
              /** Буфер поля Этаж */
              bufferFloor: null,
              /**  Буфер поля квартира */
              bufferFlat: null,
              /** Буфер поля Комментарий к адреса */
              bufferComment: null,
              /**  Буфер поля Подъзд */
              bufferEntry: null,
              /** Выбранная дата для переноса корзины */
              selectedTransferDate: null,
              /** Служебное поле для аксимальной даты, отображаемой в календаре для переноса дня */
              maxDate: new Date(),
              /** Служебное поле для минимальной даты, отображаемой в календаре для переноса дня */
              minDate: new Date(),
              /** Слуджебное поле для календаря  */
              calendar: [],
              /**  Отображаемая дата в человечьем формате*/
              showingDateFormat: null,
              /**  Отображаемая дата в человечьем формате (дд.мм.гггг)*/
              showingDateFormatAlt: null,
              /** Служебное поле календаря  */
              calendarDateValue: null,
              calendarDateValueEx: null,
              /** Легаси поле вывода ошибок аякс */
              ajaxUserError: null,
              /**@todo какой то служебный флаг  */
              isCheckOut: false,
              /**  Массив заблокированных дней в календаре */
              calendarDateDisabled: window.datesDisabled,
              /** Стоп-лист */
              stopList: window.stopList,
              /** Служебное - текущая дата */
              currentDate: moment().format(MOMENT_DATE_FORMAT),
              /**  Служебное - текущая дата в человечьем формате */
              currentDatePlural: moment().format('Do MMMM'),
              /**  Служебное -  дата числа, которое после сегодня */
              tomorrowDate: moment().add(1, 'days').format(MOMENT_DATE_FORMAT),
              /**  @todo */
              deliveryInfo: window.deliveryInfo,
              /** @todo  */
              deliveryInfoCart: false,
              /** @todo  */
              minPrice: 0,
              /** @todo  */
              minPriceFormat: 0,
              /** @todo  */
              dataDeliveryAllow: {},
              /** Данные о компании пользователя (массив UserCompany.php ) */
              company: window.company,
              /** Интсанс-яндекс карты */
              map: false,
              /** Таймер для аякс лоадера*/
              serviceLoaderTimeout: null,
              /**  Массив сдачи с наличных */
              changesList: window.changesList,
              /**  Выбранное значение сдачи с наличных*/
              changeSelected: '-',
              /** Массив список оплат */
              paymentList: window.paymentList,
              /** Выбранный индекс из paymentList - он же ID типа оплаты*/
              paymentSelected: window.paymentSelected,
              /** Служебное поле для оплат*/
              paymentRejected: {},
              /** Список столовых приборов*/
              cutlery: window.cutlery,
              /** Список выбранных столовых приборов */
              cutlerySelected: {
                'knives': 0,
                'spoons': 0,
                'forks': 0,
              },
              /** Имя пользователя*/
              firstname: window.firstName,
              /** Телефон пользователя*/
              phoneNumber: window.phoneNumber,
              /** Емаил пользователя */
              email: window.email,
              /** Общий комментарий*/
              orderComment: '',
              /** Form action URL */
              actionURL: window.actionURL,
              roistatID: window.roistatID,
              showScehdule: false,
              /** Нерешаемый временный фикс */
              selectedBranchName: 'Выберите филиал',
              merchantDelivery: window.merchantDelivery,
              workingTime:window.workingTime
            },
            beforeDestroy () {
              if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
              }
            },
            directives: { ClickOutside },
            created: function () {
              if (Object.keys(this.days).length) {
                this.showingDate = Object.values(window.calendarData).values().next().value['FULL_DATE']
                this.selectedTransferDate = this.showingDate

                let pickUpBranches = Object.keys(this.pickUpBranches)

                if (pickUpBranches.length) {
                  let selectedBranch = false
                  if (this.$isPickUpAddress(this.getFirstDate())) {
                    this.showPickUpPane = true
                    Object.values(this.pickUpBranches).forEach((value) => {
                      if (!selectedBranch && this.deliveryLocation[this.getFirstDate()]['TERMINAL_ID'] === value['TERMINAL_ID']) {
                        selectedBranch = value['ID']
                      }
                    })
                  } else {
                    selectedBranch = pickUpBranches.shift()
                  }
                  Object.keys(this.days).forEach(
                    (date) => {
                      if (this.$isPickUpAddress(this.getFirstDate())) {
                        this.pickupBranchSelected[date] = selectedBranch
                      }
                    }
                  )
                }

                if (Object.keys(this.profileAddress).length) {
                  Object.keys(this.days).forEach(
                    (date) => {
                      this.profileAddressSelected[date] = this.profileAddress[0]
                    }
                  )
                }

                this.setShowingDateFormat()
                this.initPopupCalendar()
                this.maxDate.setDate(this.maxDate.getDate() + 14)
                this.getDaysPlural()

                //включаем редактор адреса, тк выбрана точка самовывоза
                let firstDate = Object.keys(this.deliveryLocation)[0]
                if (this.deliveryLocation[firstDate]['SELF_PICKUP']) {
                  this.tDeliveryEditNow = true
                }

                if (this.hasCompany() && !this.canOrderToday() && this.$hasTodayDelivery()) {
                  this.showCompanyDayDisabled = true
                } else {
                  if (Object.keys(this.stopList['ITEMS']).length) {
                    this.showStopListModal = true
                  }
                }

                let fnOnSuccess = () =>{
                  this.$setDeliveryBuffer(this.showingDate,true);
                }

                /**  для первого дня чек цен */
                if (Object.keys(this.days).length === 1) {
                  this.checkDeliveryPrices(this.getFirstDate(),fnOnSuccess);
                } else {
                  this.showScehdule = true
                  let arDates = Object.keys(this.days)
                  arDates.forEach((date) => {
                    this.checkDeliveryPrices(date,fnOnSuccess)
                  })
                }
              }
            },
            validations: {
              firstname: {
                required,
                minLength: (2),
              },
              phoneNumber: {
                required,
                correctAddress (address) {
                  return /(\+7|8)[- _]*\(?[- _]*(\d{3}[- _]*\)?([- _]*\d){7}|\d\d[- _]*\d\d[- _]*\)?([- _]*\d){6})/.test(address)
                }
              }
            },
            mounted () {
              console.log('test message – mounted 6')
              this.onResize()
              window.addEventListener('resize', this.onResize.bind(this), { passive: true })
            },
            watch: {
              loader (spin) {
                if (spin && !this.showPanelCheckout) {
                  this.serviceLoaderTimeout = setTimeout(() => {
                    this.loader = false
                  }, 3500)
                } else {
                  clearTimeout(this.serviceLoaderTimeout)
                }
              },
              semaphorePriceWarning (value) {
                if (value === true) {
                  this.tDeliveryEditNow = false
                  this.$purgeDeliveryBuffer(true)
                }
                console.error('SEMAPHORE PRICE WARNING SET TO ' + value)
              },
              calendarDateValue (value) {
                console.log(value)
                let mDate = moment(value)
                if (mDate.isValid()) {
                  let keyDate = mDate.format(MOMENT_DATE_FORMAT)
                  if (this.showingDate !== keyDate && !this.carts[keyDate]) {
                    console.log('init transfer!')
                    this.moveCartToDate(keyDate)
                  }
                }
              },
              showPanelAddress (isOpened) {
                console.log('showPanelAddress ' + isOpened)
                if (isOpened) {
                  this.$resolveAddressPanelState(this.showingDate)
                  this.showAddressModal = false
                }
              },
              showPanelCheckout (isOpened) {
                if (isOpened) {
                  this.rebuildPaymentsList()
                  this.$renameOnlinePayments()
                }
              },
              showAddressModal (isOpened) {
                if (isOpened) {
                  $('.delivery__street-input').removeClass('delivery__error')
                  $('.delivery__value').removeClass('delivery__error')
                  this.$purgeDeliveryBuffer()
                  this.$resolveAddressPanelState(this.showingDate)
                  this.onRevealModalOpened()
                } else {
                  if (this.tDeliveryEditNow) {
                  }
                  this.onRevealModelClosed()
                }
              },
              showPickUpPane (isOpened) {
                if (isOpened && !this.$isFirstStage()) {
                  //this.$resolveAddressPanelState(this.showingDate)
                }
              },
              showTimeModal (isOpened) {
                if (isOpened) {
                  this.onRevealModalOpened()
                } else {
                  this.pSaveSelectedTime(this.showingDate)
                  this.onRevealModelClosed()
                }
              },
              showWorkingTimeAttentionModal(isOpened){
                if (isOpened) {
                  this.onRevealModalOpened()
                } else {
                  this.onRevealModelClosed()
                }
              },
              tDeliveryEditNow (value) {
              },
              showDeliveryPrice (isOpened) {
                if (isOpened) {
                  this.onRevealModalOpened()
                } else {
                  this.onRevealModelClosed()
                }
              },
              showCompanyDayDisabled (isOpened) {
                console.log('has company open change')
                if (isOpened) {
                  this.onRevealModalOpened()
                } else {
                  this.onRevealModelClosed()
                }
              },
              days: {
                handler: function () {
                  this.getDaysPlural()
                },
                deep: true,
              },

              deliveryTimeSelected: {
                handler: function () {
                  this.yandexReachGoal('checkout-delivery-time')
                },
                deep: true,
              },

              bufferFlat(newValue,oldValue){
                if (newValue && newValue.toString().length > 10){
                  this.bufferFlat = oldValue;
                }
              },
              bufferEntry(newValue,oldValue){
                if (newValue && newValue.toString().length > 10){
                  this.bufferEntry = oldValue;
                }
              },
              bufferFloor(newValue,oldValue){
                if (newValue && newValue.toString().length > 10){
                  this.bufferFloor = oldValue;
                }
              },



              showingDate: function (value) {
                console.warn('showingDate was change')
                this.selectedTransferDate = this.showingDate
                if (this.days[value]['DEPOSIT']) {
                  this.currentDateDeposit = this.days[value]['DEPOSIT']
                }
                this.initPopupCalendar()
              }
            },
            computed: {},
            methods: {

              moveCartToDate (date) {

                console.warn('init cart trans')
                this.loader = true
                this.ajaxUserError = null
                axios.request(
                  {
                    url: window.location.href,
                    method: 'post',
                    params: {
                      action: 'moveCart',
                      from: this.showingDate,
                      to: date,
                      deliveryLocation: this.deliveryLocation[this.showingDate]
                    },
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },

                  }
                ).then(response => {
                    this.loader = false
                    console.log(response.data)
                    if (response.data.success) {
                      this.yandexReachGoal('checkout-cart-transfered')
                      this.ajaxUserError = null
                      let previousDate = this.showingDate
                      let GUID = this.deliveryLocation[previousDate]['LOCATION']['terminal_id']
                      this.carts[date] = response.data['CARTS'][date]
                      this.days[date] = response.data['DAYS'][date]
                      this.total[date] = response.data['TOTAL'][date]
                      this.deliveryTimeList[date] = response.data['DELIVERY_TIME_LIST'][date]
                      this.$nextTick(
                        () => {
                          if (this.isDeliveryTimeCorrect(date, previousDate)){
                            this.deliveryTimeSelected[date][GUID] =    this.deliveryTimeSelected[previousDate][GUID];
                          }
                          this.deliveryLocation[date] = this.deliveryLocation[previousDate]
                          this.showingDate = date
                          delete this.deliveryTimeSelected[previousDate]
                          delete this.deliveryLocation[previousDate]
                          delete this.deliveryTimeList[previousDate]
                          delete this.carts[previousDate]
                          delete this.total[previousDate]
                          delete this.days[previousDate]
                          if (this.$isFirstStage()) {
                            this.$forceUpdate()
                          }
                        }
                      )

                    } else if (response.data.errorMessage) {
                      this.ajaxUserError = response.data.errorMessage
                    }
                  }
                ).catch(
                  error => {
                    this.loader = false
                    console.log(error)
                  }
                )
              },
              checkBranchBusy () {
                if (this.getFirstDate() === this.currentDate && !this.deliveryLocation[this.currentDate]['SELF_PICKUP']) {
                  try {
                    let selectedAddress = this.deliveryLocation[this.currentDate]
                    let arBranches = Object.values(this.pickUpBranches)
                    this.$nextTick(() => {
                      if (!this.$isFinalStage()) {
                        arBranches.forEach(
                          (branch) => {
                            if (branch['TERMINAL_ID'] === selectedAddress['TERMINAL_ID']
                              && branch['IS_BUSY'] === 'Y'
                            ) {
                              this.showDeliveryBusy = true
                            }
                          }
                        )
                      }
                    })

                  } catch (e) {
                    console.log(e)
                  }
                }
                return this.showDeliveryBusy
              },
              showMapLabel (date) {

              },

              isDeliveryTimeCorrect (date, previousDate = null) {
                this.ajaxUserError = null
                let checkableDate = previousDate ? previousDate : date;
                let timeSelected = this.deliveryTimeSelected[checkableDate]

                let isSelfPickup = this.deliveryLocation[checkableDate]['SELF_PICKUP'];
                let GUID = this.deliveryLocation[checkableDate]['LOCATION']['terminal_id'];
                if (isSelfPickup) {
                  if (!this.deliveryTimeList[checkableDate][GUID]['PICKUP'].includes(timeSelected)) {
                    this.deliveryTimeSelected[date]=  {GUID:{}};
                    this.deliveryTimeSelected[date][GUID] = this.deliveryTimeList[date][GUID]['PICKUP'][0]
                    this.pSaveSelectedTime(date)
                    return false
                  }
                } else {
                  if (!this.deliveryTimeList[checkableDate][GUID]['DELIVERY'].includes(timeSelected)) {
                    this.deliveryTimeSelected[date]=  {GUID:{}};
                    this.deliveryTimeSelected[date][GUID] = this.deliveryTimeList[date][GUID]['DELIVERY'][0]
                    this.pSaveSelectedTime(date)
                    return false
                  }
                }

                return true
              },
              setShowingDateFormat () {
                let date = moment(this.showingDate, 'YYYY-MM-DD')
                this.showingDateFormat = date.format('D MMMM YYYY г')
                this.showingDateFormatAlt = date.format('DD.MM.YYYY')
              },
              tPrintDateFormat () {
                let newdate = moment(this.showingDate, 'YYYY-MM-DD')
                return newdate.format('D MMMM YYYY г')
              },
              vCalGetDayName (date) {

                return daysOfWeek[date.weekday]
              },
              initPopupCalendar () {
                this.calendar = []
                Object.keys(this.days).forEach(
                  (value) => {
                    this.calendar.push(
                      {

                        highlight: {
                          fillMode: 'solid',
                          style: { 'background': this.showingDate === value ? '#D31340' : '#73808D' },
                        },
                        popover: {
                          visibility: 'click',
                          hideIndicator: true,
                        },
                        dates: new Date(value),
                      }
                    )
                  }
                )
                if (!this.canOrderToday()) {
                  this.minDate = new Date()
                  this.minDate.setDate(this.minDate.getDate() + 1)
                }
                this.setShowingDateFormat()
              },
              $hasAddressEditErrors () {
                console.log('check errors')
                let streetError = false
                let houseError = false
                if (!this.bufferStreet) {
                  if (this.$isFirstStage()) {
                    $('[data-entity="delivery-error-street"]').addClass('delivery__error')
                  } else {
                    let $autoComplete = $(this.$refs.popupAutoComplete[0].$refs.input)
                    $autoComplete.addClass('delivery__error')
                  }
                  streetError = true
                } else {
                  if (this.$isFirstStage()) {
                    $('[data-entity="delivery-error-street"]').removeClass('delivery__error')
                  } else {
                    let $autoComplete = $(this.$refs.popupAutoComplete[0].$refs.input)
                    $autoComplete.removeClass('delivery__error')
                  }

                }
                if (!this.bufferHouse) {
                  streetError = true
                  $('[data-entity="delivery-error-house"]').addClass('delivery__error')
                } else {
                  $('[data-entity="delivery-error-house"]').removeClass('delivery__error')
                }
                return streetError === true || houseError === true
              },

              /**
               *
               * @param date
               * @param {function|null} onSuccess
               * @returns {boolean}
               */
              checkDeliveryAddress (date, onSuccess) {
                if (!this.resolveAddressEditor(date)) {
                  return false
                }
                console.warn(onSuccess)
                let postData = {
                  action: 'checkLocation',
                  date: date,
                }

                let isProfileAddress = false
                let loc = this.deliveryLocation[date]
                if (this.$tIsProfileAddressSelected(date)) {
                  isProfileAddress = true
                  postData['address'] = loc['ADDRESS']['street']
                  postData['house'] = loc['ADDRESS']['house']
                  postData['housing'] = loc['ADDRESS']['housing']
                  console.warn('collect data from profile address', postData)
                } else {
                  postData['address'] = this.bufferStreet
                  postData['house'] = this.bufferHouse
                  postData['housing'] = this.bufferHousing
                  console.warn('collect data from buffer', postData)
                }

                this.$purgeDeliveryBuffer(false)
                this.loader = true
                axios.request(
                  {
                    url: window.location.href,
                    method: 'post',
                    params: postData,
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },

                  }
                ).then(
                  response => {
                    this.loader = false
                    /**
                     * Проверка на наличие блюд в стоп-листе у казанной даты
                     */
                    if (response.data['STOP_LIST']
                      && Object.keys(response.data['STOP_LIST']['ITEMS']).length
                    ) {
                      this.stopList = response.data['STOP_LIST']
                      this.stopList['LOCATION'] = response.data['LOCATION']
                      this.showAddressModal = false
                      this.showStopListModal = true
                      console.log('here?')
                    } else {
                      this.deliveryLocation[date] = response.data.LOCATION

                      /**
                       * @ todo fix profile flag
                       */
                      if (isProfileAddress) {
                        this.deliveryLocation[date]['IS_PROFILE'] = true
                        this.$purgeDeliveryBuffer()
                      }
                      this.pSaveSelectedLocation(date)
                      if (this.$isFirstStage() && this.semaphoreFirstEntry) {
                        this.$replicateAddressFromDate(date)
                        this.tDeliveryEditNow = false
                        this.checkRules(onSuccess)
                      }
                      this.isDeliveryTimeCorrect(date)
                      this.checkDeliveryPrices(date, onSuccess)
                    }

                    /**
                     * @todo отрефакторить в обработчике кнопок модалки стоплиста
                     */
                    if (!this.$isFirstStage()) {
                      this.tDeliveryEditNow = false
                    }
                    return true
                  }
                ).catch(
                  () => {
                    this.loader = false
                    this.$purgeDeliveryBuffer()
                  }
                )
              },

              getDeliveryDataQuite (address) {
                return axios.request(
                  {
                    url: '/ajax/user-location.php',
                    method: 'post',
                    params: {
                      'action': 'getPrices',
                      'address': address['ADDRESS']['street'],
                      'house': address['ADDRESS']['house'],
                      'passSave': true,
                    },
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                  }
                )
              },

              resolveAddressEditor (date) {
                if (this.tDeliveryEditNow) {
                  if (this.$isUserProfileAddressExist()) {
                    if (!this.bufferHouse && !this.bufferStreet && !this.$isProfileAddress(date)) {
                      console.warn('FIRST PROFILE WAS SELECTED')
                      this.setProfileAddress(date, 0)
                      return true
                    }
                  } else {
                    return !this.$hasAddressEditErrors()
                  }
                }
                return true
              },

              $isUserProfileAddressExist () {
                return Object.values(this.profileAddress).length !== 0
              },
              /**
               * @attention
               *  Вью проставляет по умолчанию в аргемент событие Event,
               *  вместо задекларированного по умолчанию
               */
              onPanelAddressNext (passBuffer = false, passAll = false) {
                this.semaphorePriceWarning = false
                if (typeof passBuffer !== 'boolean') {
                  passBuffer = false
                }
                if (typeof passAll !== 'boolean') {
                  passAll = false
                }
                if (passBuffer && !passAll){
                  this.$getAddressAdditional();
                }

                if (this.$isFirstStage() && !this.resolveAddressEditor(this.showingDate)) {
                  return false
                }
                let fnOnNext = () => {
                  console.warn('call on next');
                  this.checkRules(() => {
                    this.$purgeDeliveryBuffer()
                    if (Object.keys(this.days).length === 1) {
                      this.semaphoreCanCheckOut = true
                      console.warn('here1?')
                      if (this.tDeliveryEditNow) {
                        this.tDeliveryEditNow = false
                        this.$forceUpdate()
                      } else {
                        //if (this.$isPickUpAddress(this.showingDate)){
                          this.$openPaneCheckOut()
                       // }
                      }
                    } else {
                      if (this.$isFirstStage()) {
                        console.warn('here2?')
                        this.semaphoreFirstEntry = false
                        this.semaphoreCanCheckOut = true
                        if (this.tDeliveryEditNow) {
                          this.tDeliveryEditNow = false
                          this.$forceUpdate()
                        } else {
                        //  if (this.$isPickUpAddress(this.showingDate)){
                            this.$openPaneCheckOut()
                         // }
                        }
                      } else {
                        console.warn('here3?')
                        this.semaphoreCanCheckOut = true
                        this.$openPaneCheckOut()
                      }
                    }
                    this.checkBranchBusy()
                  })
                }
                if (passBuffer === false && (this.bufferStreet || this.bufferHouse)) {
                  console.warn('[1]  - Set Address from Buffer')
                  this.yandexReachGoal('checkout-address-filled')
                  if (!this.$hasAddressEditErrors()) {
                    let bAddress = {
                      'ADDRESS': {
                        'street': this.bufferStreet,
                        'house': this.bufferHouse
                      }
                    }
                    this.loader = true
                    this.getDeliveryDataQuite(bAddress).then((response) => {
                      let address = response.data
                      this.checkStopList(() => {
                        this.loader = false
                        if (Object.keys(stopList['ITEMS']).length > 0) {
                          this.$data.showStopListModal = true
                        } else {
                          this.deliveryLocation[this.showingDate] = address
                          if (this.$isFirstStage()) {
                            this.$replicateAddressFromDate(this.showingDate)
                          }
                          fnOnNext()
                        }
                      }, address['TERMINAL_ID'])
                    }).catch(() => {
                      this.loader = false
                    })
                  }

                } else {
                  if (this.tDeliveryEditNow) {
                    if (Object.keys(this.profileAddress).length && !passAll) {
                      this.setProfileAddress(this.showingDate, 0)
                    } else if (!passAll && this.$hasAddressEditErrors()) {
                      return
                    }
                  }

                  if (this.$isFirstStage()) {
                    this.$replicateAddressFromDate(this.showingDate)
                    this.semaphoreFirstEntry = true
                  }

                  if (this.$isProfileAddress(this.showingDate) || this.$isPickUpAddress(this.showingDate)
                    || this.$isCompleteAddress(this.showingDate)) {
                    fnOnNext()
                  } else {
                    console.error('need edit and check!')
                  }
                }

              },

              cnangeDeliveryTime (value,GUID) {
                this.deliveryTimeSelected[this.showingDate][GUID] = value
                this.showDeliveryTimeContainer = false
              },
              changeCalendarDate (dateObject) {
                console.log(dateObject)
                if (dateObject.isDisabled === false) {

                  if (this.showingDate !== dateObject.id && !this.carts[dateObject.id]) {
                    console.log('init transfer!')
                    this.moveCartToDate(dateObject.id)
                    this.showDeliveryDateContainer = false
                  }
                }
              },
              setAddressDate (date) {
                let bufferFiller = (dateValue) => {
                  this.deliveryLocation[dateValue]['ADDRESS']['floor'] = this.bufferFloor
                  this.deliveryLocation[dateValue]['ADDRESS']['flat'] = this.bufferFlat
                  this.deliveryLocation[dateValue]['ADDRESS']['comment'] = this.bufferComment
                  this.deliveryLocation[dateValue]['ADDRESS']['entry'] = this.bufferEntry
                  this.deliveryLocation[dateValue]['ADDRESS']['housing'] = this.bufferHousing
                  if (this.bufferFlat) {
                    this.deliveryLocation[dateValue]['IS_NOT_COMPLETE'] = false
                  }
                }

                if (!this.$isCompleteAddress(date) && this.$isSameDeliveryLocations()) {
                  let arDays = Object.keys(this.days)
                  arDays.forEach(
                    index => {
                      bufferFiller(index)
                    }
                  )
                } else {
                  bufferFiller(date)
                }
                this.pSaveSelectedLocation(date)
              },

              setProfileAddress (date, index) {
                console.trace('setProfileAddress')
                this.semaphoreCanCheckOut = false
                this.yandexReachGoal('checkout-profile-address')
                this.$purgeDeliveryBuffer()
                this.showProfileContainer = false
                this.profileAddressSelected[date] = this.profileAddress[index]
                let fnSelect = () => {
                  console.warn('Profile address was selected by index => ' + index)
                  this.deliveryLocation[date] = this.profileAddress[index]
                  this.tDeliveryEditNow = false
                  if (this.$isFirstStage()) {
                    this.resolveAddressEditor(date)
                    this.$replicateAddressFromDate(date)
                  } else {
                    this.$resolveAddressPanelState(date)
                  }
                  this.$setDeliveryBuffer(this.showingDate,true);
                }
                if (this.profileAddress[index]['PRICES'] === undefined) {
                  this.loader = true
                  this.getDeliveryDataQuite(this.profileAddress[index]).then((response) => {
                    this.profileAddress[index]['PRICES'] = response.data['PRICES']
                    this.profileAddress[index]['LOCATION'] = response.data['LOCATION']
                    this.profileAddress[index]['DELIVERY_TIME'] = response.data['DELIVERY_TIME']
                    fnSelect()
                    this.loader = false
                  }).catch(() => {
                    this.loader = false
                  })
                } else {
                  fnSelect()
                }

              },
              $tShowDeliveryTime (date) {
                let loc = this.deliveryLocation[date]
                return loc['DELIVERY_TIME'] && (Number(loc['DELIVERY_TIME']) > 0)
              },

              $tShowAddressWarning (date) {
                let loc = this.deliveryLocation[date]
                if (!this.$hasDeliveryPrice(date)) {
                  return true
                }
                if (loc['SELF_PICKUP']) {
                  return false
                }
                if (loc['DELIVERY_TIME'] === undefined) {
                  return false
                }
                if (loc['PRICES']['todayPrice'] === undefined) {
                  return true
                }
                console.warn(date)
                let cartPrice = Number(this.days[date]['PRICE'])
                if (date === this.currentDate) {
                  return loc['PRICES']['todayPrice'] == '1' || cartPrice < Number(loc['PRICES']['todayPrice'])
                }
                return cartPrice < Number(loc['PRICES']['tomorrowPrice'])
              },

              $hasDeliveryPrice (date) {
                return this.deliveryLocation[date]['PRICES'] !== undefined && this.deliveryLocation[date]['PRICES']['todayPrice'] !== undefined
              },
              $enableDeliveryAddressEdit (date) {
                try {
                  console.log('enableAddressEdit')
                  this.tDeliveryEditNow = true
                  /**
                   * @todo вспомнить что не так
                   */
                  // delete this.deliveryLocation[date]['DELIVERY_TIME']
                  // delete this.deliveryLocation[date]['PRICES']

                  this.$purgeDeliveryBuffer()
                  if (!this.deliveryLocation[date]['IS_PROFILE'] || !this.deliveryLocation[date]['SELF_PICKUP']) {
                    this.$setDeliveryBuffer(date)
                  } else {
                    console.log('pass buffer')
                  }
                  //  console.log('$enableDeliveryAddressEdit');
                  this.$forceUpdate()
                } catch (e) {
                  console.log(e)
                }
              },
              $isSameDeliveryLocations () {
                let arLocations = Object.values(this.deliveryLocation)
                if (arLocations.length === 1) {
                  return true
                }

                let defLocation = {
                  'street': arLocations[0]['ADDRESS']['street'],
                  'house': arLocations[0]['ADDRESS']['house'],
                  'housing': arLocations[0]['ADDRESS']['housing'],
                  'flat': arLocations[0]['ADDRESS']['flat'],
                }
                for (let i = 1; i < arLocations.length; i++) {
                  let address = arLocations[i]['ADDRESS']
                  if (defLocation['street'] != address['street']) {
                    return false
                  }
                  if (defLocation['house'] != address['house']) {
                    return false
                  }
                  if (defLocation['housing'] != address['housing']) {
                    return false
                  }
                  if (defLocation['flat'] != address['flat']) {
                    return false
                  }

                }
                return true
              },
              $isProfileAddress (date) {
                return Boolean(this.deliveryLocation[date]['IS_PROFILE'])
              },
              $isCompleteAddress (date) {
                if (this.showPanelAddress) {
                  /**
                   * @todo replicate anothers
                   * @type {boolean}
                   */
                  this.deliveryLocation[date]['IS_NOT_COMPLETE'] = false
                }
                return !this.deliveryLocation[date]['IS_NOT_COMPLETE']
              },
              $isManualSetAddress (date) {
                return !this.$isProfileAddress(date) && !this.$isPickUpAddress(date)
              },
              $isPickUpAddress (date) {
                return Boolean(this.deliveryLocation[date]['SELF_PICKUP'])
              },
              $setDeliveryBuffer (date, passStreetBuffer = false) {
                console.error('$setDeliveryBuffer')
                if (this.deliveryLocation[date] && !this.deliveryLocation[date]['SELF_PICKUP']) {
                  this.$purgeDeliveryBuffer()
                  let address = this.deliveryLocation[date]['ADDRESS']
                  console.warn(address);
                  if (!passStreetBuffer) {
                    this.bufferStreet = address['street'] ??''
                    this.bufferHouse = address['house'] ??''
                  }
                  this.bufferHousing = address['housing'] ??''
                  this.bufferFlat = address['flat'] ?? ''
                  this.bufferFloor = address['floor'] ??''
                  this.bufferComment = address['comment'] ??''
                  this.bufferEntry = address['entry'] ?? ''
                }
              },
              $purgeDeliveryBuffer (purgeStreet = true, purgeAdditional = true) {
                if (purgeStreet) {
                  this.bufferStreet = null
                  this.bufferHouse = null
                  if (this.$refs.streetAutocomplete !== undefined) {
                    this.$refs.streetAutocomplete.setValue('')
                  }
                }
                if (purgeAdditional){
                  this.bufferHousing = null
                  this.bufferFlat = null
                  this.bufferFloor = null
                  this.bufferComment = null
                  this.bufferEntry = null
                }
              },

              /**
               *  Реплицирует адреса на все последующие дни
               * @param {string} date
               */
              $replicateAddressFromDate (date) {
                this.semaphorePriceWarning = false
                console.warn('REPLICATE FOR ' + date)
                let arDays = Object.keys(this.days)
                arDays.forEach((value) => {

                  if (value !== date) {
                    this.deliveryLocation[value] = this.deliveryLocation[date]
                    console.log('set for ' + date)
                  }
                })
              },
              setPicupDate (date) {
                this.yandexReachGoal('checkout-pickup')
                this.semaphorePriceWarning = false
                this.showBranchSelectContainer = false
                if (!this.pickupBranchSelected[date]) {
                  let branchId = Object.keys(this.pickUpBranches)
                  if (!branchId[0]) {
                    return
                  }
                  this.pickupBranchSelected[date] = branchId[0]
                }
                if (this.$isFirstStage()) {
                  this.$forceUpdate()
                }
                let pickUpCandidate = this.pickUpBranches[this.$data.pickupBranchSelected[date]]
                this.selectedBranchName = pickUpCandidate['NAME']
                this.checkStopList(
                  (stopList) => {
                    if (Object.keys(stopList['ITEMS']).length > 0) {
                      this.selectedBranchName = 'Выберите филиал'
                      console.log('purge selected for date ' + date)
                      this.$data.stopList['LOCATION'] = pickUpCandidate
                      delete this.$data.pickupBranchSelected[date]
                      if (!this.showPanelAddress) {
                        this.$data.showAddressModal = false
                        this.$data.showPickUpPane = false
                      }
                      this.$data.showStopListModal = true
                    } else {
                      console.log('self pickup stoplist ok')
                      this.$data.deliveryLocation[date] = pickUpCandidate
                      if (this.$isFirstStage()) {
                        this.$replicateAddressFromDate(date)
                      }
                      this.pSaveSelectedLocation(date)
                      if (!this.showPanelAddress) {
                        this.$data.showAddressModal = false
                        this.showPickUpPane = false
                        this.$enableDeliveryAddressEdit(date)
                      } else {
                        this.semaphoreCanCheckOut = true
                        this.semaphoreFirstEntry = false
                        this.$openPaneCheckOut()
                      }
                    }

                  }, pickUpCandidate['TERMINAL_ID']
                )

              },
              streetSearch: function (value) {
                const url = `/ajax/autocompleteAddress2.php?term=${encodeURI(value)}`
                return new Promise(
                  (resolve) => {
                    fetch(url)
                      .then((response) => response.json())
                      .then(
                        (data) => {
                          let out = []
                          data.forEach(
                            function (street) {
                              out.push(street.value)
                            }
                          )
                          resolve(out)
                        }
                      )
                  }
                )
              },
              getStreetResultValue (result) {
                return result
              },
              test: function () {
                console.log(this.deliveryLocation[this.showingDate]['ADDRESS']['street'] + ' ' + this.deliveryLocation[this.showingDate]['ADDRESS']['house'])
              },

              onCheckOutNext () {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                  let $stepOne = $(this.$refs.checkOutStepOne)
                  let $stepTwo = $(this.$refs.checkOutStepTwo)
                  let $comment = $(this.$refs.checkOutStepTwoComment)
                  let $nextButton = $(this.$refs.checkOutStepOneButtonNext)
                  let $orderButton = $(this.$refs.checkOutStepTwoButtonOrder)
                  $stepOne.fadeOut(350, () => {
                    $nextButton.remove()
                    $stepTwo.removeClass('hide-for-small-only')
                    $comment.removeClass('hide-for-small-only')
                    $orderButton.removeClass('hide')
                  })
                }
              },
              getDaysPlural: function () {
                let decCases = [2, 0, 1, 1, 1, 2]
                let titles = ['день', 'дня', 'дней']
                let count = Object.keys(this.days).length
                if (!this.decCache[count]) {
                  this.decCache[count] = count % 100 > 4 && count % 100 < 20 ? 2 : decCases[Math.min(count % 10, 5)]
                }
                this.daysCountPlural = titles[this.decCache[count]]
              },
              onResize () {
                this.isMobile = window.innerWidth < 600
                if (this.isMobile) {
                  this.settings = {
                    'dots': false,
                    'edgeFriction': 0.35,
                    'infinite': true,
                    'speed': 500,
                    'slidesToShow': 3,
                    'slidesToScroll': 3
                  }
                } else {
                  this.settings = {
                    'dots': false,
                    'edgeFriction': 0.35,
                    'infinite': true,
                    'speed': 500,
                    'slidesToShow': 7,
                    'slidesToScroll': 7
                  }
                }
              },
              showNextDays () {
                this.$refs.calendar.next()
              },
              showPrevDays () {
                this.$refs.calendar.prev()
              },
              getItem (date, index) {
                if (this.carts[date]['PRODUCTS'][index]) {
                  return this.carts[date]['PRODUCTS'][index]
                }
                return false
              },
              /**
               *  Присваивает адрес буферу из компонента автокомплита улицы
               * @param result
               */
              streetSubmit (result) {
                this.bufferStreet = result
              },
              /**
               *  Возвращает дату первого дня в козине
               * @returns {string}
               */
              getFirstDate () {
                return Object.keys(this.days)[0]
              },
              getLastDate () {
                return Object.keys(this.days).reverse()[0]
              },
              /**
               *  Обработчик проверки на заблокированные дни для оформления заказа
               */
              checkBlockDays () {
                console.log('checkBlockDays')
                this.loader = true
                this.showDeliveryPrice = false
                this.showAddressModal = false
                this.transferedDate = null
                if (this.days[this.currentDate]) {
                  console.log('current date need to check')
                  axios.request(
                    {
                      url: window.location.href,
                      method: 'post',
                      params: {
                        action: 'resolveBlockedDays',
                        day: this.currentDate,
                        deliveryLocation: this.deliveryLocation[this.currentDate]
                      },
                      headers: { 'X-Requested-With': 'XMLHttpRequest' },

                    }
                  ).then(
                    response => {
                      this.loader = false
                      this.transferedDate = null
                      let data = response.data
                      if (data['TRANSFER']) {
                        this.ajaxUserError = null
                        let newDate = data['TRANSFER']['TO']
                        this.deliveryTimeList = data['DELIVERY_TIME_LIST']
                        this.deliveryLocation[newDate] = this.deliveryLocation[this.currentDate]
                        this.deliveryTimeSelected[newDate] = this.deliveryTimeSelected[this.currentDate]
                        this.carts = data['CARTS']
                        this.days = data['DAYS']
                        this.ajaxUserError = null
                        this.transferedDate = moment(newDate, MOMENT_DATE_FORMAT).format('D MMMM')
                        this.$nextTick(
                          () => {
                            delete this.days[this.currentDate]
                            delete this.carts[this.currentDate]
                            this.showingDate = newDate
                            this.showCartTransfer = true
                          }
                        )
                      }
                    }
                  ).catch(
                    error => {
                      this.loader = false
                      console.log(error)
                    }
                  )
                }
              },
              /**
               * Обработчик собатия на открытие модалки
               */
              onRevealModalOpened () {
                $('html').addClass('is-reveal-open').addClass('zf-has-scroll')
              },
              /**
               * Обработчик события на закрытие модалки
               */
              onRevealModelClosed () {
                $('html').removeClass('is-reveal-open').removeClass('zf-has-scroll')
              },

              /**
               *  Проверяет корзину на наличие товаров в стоп листе
               * @param {function|null} callable
               * @param {string} forceGuid
               */
              checkStopList (callable, forceGuid = null) {
                this.loader = true
                axios.request(
                  {
                    url: window.location.href,
                    method: 'post',
                    params: {
                      action: 'checkStopList',
                      terminalID: forceGuid ? forceGuid : this.deliveryLocation[this.showingDate]['TERMINAL_ID'],
                    },
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },

                  }
                ).then(
                  response => {
                    this.loader = false
                    let data = response.data
                    this.stopList = data['STOP_LIST']
                    if (typeof (callable) === typeof (Function)) {
                      callable(this.stopList)
                    }
                  }
                ).catch(() => {
                  this.loader = false
                })
              },
              /**
               *  Обновляет суммарный итог
               * @param {string} data
               */
              updateTotalData (data) {
                TweenLite.to(
                  this.$data.total, 1, {
                    'BASE_PRICE': data.TOTAL.BASE_PRICE,
                    roundProps: 'BASE_PRICE'
                  }
                )
                TweenLite.to(
                  this.$data.total, 1, {
                    'DISCOUNT': data.TOTAL.DISCOUNT,
                    roundProps: 'DISCOUNT'
                  }
                )
                TweenLite.to(
                  this.$data.total, 1, {
                    'FINAL_PRICE': data.TOTAL.FINAL_PRICE,
                    roundProps: 'FINAL_PRICE'
                  }
                )
                TweenLite.to(
                  this.$data.total, 1, {
                    'QUANTITY': data.TOTAL.QUANTITY,
                    roundProps: 'QUANTITY'
                  }
                )
                if (this.$data.total.DEPOSIT != false) {
                  TweenLite.to(
                    this.$data.total, 1, {
                      'DEPOSIT': data.TOTAL.DEPOSIT,
                      roundProps: 'DEPOSIT'
                    }
                  )
                }
              },

              $hasTodayDelivery () {
                return Object.keys(this.days).includes(this.currentDate)
              },

              /**
               *  Проверка всей корзины на все имеющиеся правила блокировки заказа
               * @param {function|null} onSuccess
               * @param  {function|null} onFault
               */
              checkRules (onSuccess = null, onFault = null) {
                if (this.hasCompany() && !this.canOrderToday() && this.$hasTodayDelivery()) {
                  this.showCompanyDayDisabled = true
                  return
                }
                console.warn('CHECK RULES')
                this.checkStopList(
                  (stopList) => {
                    console.log('stopList', stopList)
                    if (Object.keys(stopList['ITEMS']).length > 0) {
                      console.log('need block')
                      this.$data.showStopListModal = true
                    } else {
                      let days = Object.keys(this.days)
                      console.warn(days)
                      let lastDate = this.getLastDate()
                      for (let i = 0; i < days.length; i++) {
                        let date = days[i]
                        if (!this.semaphorePriceWarning) {
                          console.error('Check for date ' + date)
                          try {
                            this.checkDeliveryPrices(
                              date, () => {
                                console.warn('Price success')
                                if (date === lastDate && !this.semaphorePriceWarning) {
                                  if (typeof (onSuccess) === typeof (Function)) {
                                    this.$nextTick(() => {
                                      onSuccess()
                                    })
                                  }
                                }
                              }
                            )
                          } catch (e) {
                            console.log(e)
                            if (typeof (onFault) === typeof (Function)) {
                              onFault()
                            }
                          }
                        } else {
                          console.warn('looks like opened')
                          return
                        }
                      }
                    }
                  }
                )
              },
              checkOut () {
                this.checkRules(() => {
                  console.log('SUBMIT!')
                })
              },

              /**
               * Обработчик события для редиректа пользователя в каталог
               */
              onStopListTakeOther () {
                axios.request(
                  {
                    url: '/ajax/calendarDateList.php',
                    method: 'post',
                    params: {
                      'store-date': 'Y',
                      'date': this.showingDate,
                    },
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                  }
                ).then(
                  () => {
                    this.catalogRedirect()
                  }
                ).catch(
                  () => {
                    this.catalogRedirect()
                  }
                )
              },
              /**
               * Обаботчик события при удалении товаров из-за стоп листа
               * Влияет на отображение шаблонов
               */
              onStopListDeleteItems () {
                this.showAddressModal = false
                this.showStopListModal = false
                this.loader = true

                console.warn(this.deliveryLocation[this.showingDate]['TERMINAL_ID'])
                axios.request(
                  {
                    url: window.location.href,
                    method: 'post',
                    params: {
                      'action': 'resolveStopList',
                      'terminalID': this.stopList['LOCATION']['TERMINAL_ID'],
                    },
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                  }
                ).then(
                  (response) => {
                    try {
                      let fnFinnaly = () => {
                        if (Object.keys(this.carts).length >= 1) {
                          this.tDeliveryEditNow = false
                          this.updateTotalData(response.data)
                          this.showStopListModal = false
                          this.deliveryLocation[this.currentDate] = this.stopList['LOCATION']
                          this.$purgeDeliveryBuffer()
                          if (this.$isFirstStage()) {
                            this.$replicateAddressFromDate(this.currentDate)
                            if (this.showPickUpPane) {
                              this.setPicupDate(this.currentDate)
                            } else {
                              this.resolveAddressEditor(this.currentDate)
                            }

                          }
                          this.stopList['ITEMS'] = []
                        } else {
                          window.location.href = '/personal/cart/'
                        }
                        this.loader = false
                      }

                      console.warn('check!', response.data['CARTS'][this.currentDate])
                      if (response.data['CARTS'] && response.data['CARTS'][this.currentDate]) {
                        console.warn('[1]')
                        this.days[this.currentDate] = response.data['DAYS'][this.currentDate]
                        this.carts[this.currentDate] = response.data['CARTS'][this.currentDate]
                        fnFinnaly()
                      } else {

                        let arDates = Object.keys(this.carts)
                        if (arDates.length > 1) {
                          console.warn('[2]')
                          console.log('delete and mayby switch no another')
                          if (this.showingDate === this.currentDate) {
                            console.log('switching to another date')
                            let index = arDates.indexOf(this.currentDate)
                            delete arDates[index]
                            this.showingDate = arDates.shift()
                          }
                        }
                        this.$nextTick(
                          () => {
                            delete this.days[this.currentDate]
                            delete this.carts[this.currentDate]
                            fnFinnaly()
                          }
                        )
                      }
                    } catch (e) {
                      this.loader = false
                      console.log(e)
                    }

                  }
                ).catch(
                  (error) => {
                    this.ajaxUserError = ''
                  }
                )
              },

              $tClosePanelDeliveryTime () {
                this.showDeliveryTimeContainer = false
              },
              $tClosePanelDeliveryDate () {
                this.showDeliveryDateContainer = false
              },

              $tClosePanelCultery () {
                console.log('close panel $tClosePanelCultery')
                this.panelCutleryOpen = false
              },
              $tClosePanelChanges () {
                console.log('close $tClosePanelChanges!')
                this.panelChangesOpen = false
                console.log('result ', this.panelChangesOpen)
              },
              $tClosePanelPayment () {
                this.panelPaymentOpen = false
              },
              /**
               *
               * @return {boolean}
               */
              $tHasPickupDeliveries () {
                let days = Object.keys(this.days)
                for (let i = 0; i < days.length; i++) {
                  if (this.$isPickUpAddress(days[i])) {
                    return true
                  }
                }
                return false
              },

              /**
               *
               */
              $renameOnlinePayments () {
                let namePickup = 'Оплата картой'
                let nameDelivery = 'Картой курьеру'
                let fnRename = (variant) => {
                  Object.values(this.paymentList).forEach((value, key) => {
                    if (ARR_ONLINE_PAMENTS_ID.includes(value['ID'])) {
                      this.paymentList[value['ID']]['NAME'] = variant
                    }
                  })
                }
                if (this.$tHasPickupDeliveries()) {
                  fnRename(namePickup)
                } else {
                  fnRename(nameDelivery)
                }

              },

              $getAddressAdditional () {
                console.warn('$getAddressAdditional')
                this.deliveryLocation[this.showingDate]['ADDRESS']['housing'] = this.bufferHousing
                this.deliveryLocation[this.showingDate]['ADDRESS']['flat'] = this.bufferFlat
                this.deliveryLocation[this.showingDate]['ADDRESS']['entry'] = this.bufferEntry
                this.deliveryLocation[this.showingDate]['ADDRESS']['floor'] = this.bufferFloor
                this.deliveryLocation[this.showingDate]['ADDRESS']['comment'] = this.bufferComment
                this.deliveryLocation[this.showingDate]['IS_NOT_COMPLETE'] = false;
              },
              $setAddressAdditional () {
                console.warn('$setAddressAdditional')
                this.bufferHousing = this.deliveryLocation[this.showingDate]['ADDRESS']['housing']
                this.bufferFlat = this.deliveryLocation[this.showingDate]['ADDRESS']['flat']
                this.bufferEntry = this.deliveryLocation[this.showingDate]['ADDRESS']['entry']
                this.bufferFloor = this.deliveryLocation[this.showingDate]['ADDRESS']['floor']
                this.bufferComment = this.deliveryLocation[this.showingDate]['ADDRESS']['comment']
              },

              $isWorkingTime(){
                if (this.getFirstDate() === this.currentDate){
                  let terminal = this.deliveryLocation[this.currentDate]['LOCATION']['terminal_id'];
                  if (this.workingTime[terminal]){
                    return this.workingTime[terminal]['IS_WORKING_NOW'];
                  }
                  return true;
                }
                return true;
              },

              /**
               * @todo учесть работу в режиме расписания и в режиме первого окна
               * Проверяет минимальные суммы дастави для указанной даты
               * @param {string} date
               * @param {function|null}onSuccess
               */
              checkDeliveryPrices (date, onSuccess = null, onFault = null) {
                console.log('init checkDeliveryPrices for date ' + date)
                let checkOutFlag = typeof (onSuccess) === typeof (Function)
                let dateKey = 'todayPrice'
                if (date !== this.currentDate) {
                  dateKey = 'tomorrowPrice'
                }
                console.warn('check for datekey is ' + dateKey)

                if (!this.deliveryLocation[date]['SELF_PICKUP'] && this.$hasDeliveryPrice(date)) {
                  console.warn(!this.deliveryLocation[date]['SELF_PICKUP'], this.deliveryLocation[date]['PRICES']['todayPrice'])
                  console.log('into check price')
                  let currentCartCost = Number(this.days[date]['PRICE'])
                  let minDeliveryPrice = Number(this.deliveryLocation[date]['PRICES'][dateKey])
                  console.log('min delivery price is ' + minDeliveryPrice + ' ( ' + dateKey + ')')
                  if (minDeliveryPrice != 1) {
                    console.log('!= 1')
                    if (currentCartCost < minDeliveryPrice) {
                      this.semaphorePriceWarning = true
                      console.warn('warning price')
                      this.yandexReachGoal('checkout-price-warning')
                      this.showingDate = date
                      this.showPickUpPane = false
                      if (this.$isFirstStage()) {
                        this.showingDate = date
                        this.$forceUpdate()
                      } else {
                        this.$updateDeliveryModalState()
                      }
                    } else {
                      //псевдофикс для расписания доставки
                      this.semaphorePriceWarning = false
                      if (dateKey === 'tomorrowPrice') {
                        this.deliveryLocation[date]['DELIVERY_TIME'] = 60
                      }
                      if (!checkOutFlag && !this.$isFirstStage()) {
                        this.$updateDeliveryModalState()
                      }
                    }
                  } else {
                    console.warn('????????')
                  }
                } else if (!this.deliveryLocation[date]['SELF_PICKUP'] && !this.$hasDeliveryPrice(date)) {
                  console.warn('no prcies and no pickup!')
                  this.yandexReachGoal('checkout-no-delivery')
                  this.semaphorePriceWarning = true
                  this.tDeliveryEditNow = false
                  this.$openPaneAddress()
                  this.$forceUpdate()
                  return false
                }


                if (date === this.getLastDate()) {
                  if (!this.semaphorePriceWarning && typeof (onSuccess) === typeof (Function)) {
                    this.$nextTick(() => {
                      if (this.$isWorkingTime()){
                        onSuccess()
                      }else{
                        this.showWorkingTimeAttentionModal = true;
                      }
                    })
                  } else {
                    console.warn('price on last date, do nothing')
                  }
                } else {
                  console.warn('date ' + date + ' is not last date')
                }
              },

              dateTransferChanged () {
                if (this.showingDate !== this.selectedTransferDate) {
                  this.moveCartToDate(this.selectedTransferDate)
                }
              },

              $tCloseProfileContainer () {
                this.showProfileContainer = false
              },
              $dateExist (date) {
                let arDates = Object.keys(this.days)
                return (arDates.indexOf(date) !== -1)
              },

              /**
               *  Проверяет является ли адрес на указанную дату
               *  адресом из профиля
               * @param {string} date
               * @returns {*|boolean}
               */
              $tIsProfileAddressSelected (date) {
                let loc = this.deliveryLocation[date]
                return loc && loc['IS_PROFILE'] && this.bufferStreet == null && this.bufferHouse == null
              },
              /**
               *  Проверяет наличие заполненных адресов
               *  скорее всего внутренний метод
               * @returns {boolean}
               */
              checkDeliveryLocationData () {
                let daykeys = Object.keys(this.days)
                this.ajaxUserError = null
                daykeys.forEach(
                  (date) => {
                    if (!this.deliveryLocation[date]['LOCATION']['terminal_id']
                      || !this.deliveryLocation[date]['ADDRESS']['street']
                      || !this.deliveryLocation[date]['ADDRESS']['house']
                    ) {
                      let date = moment(date, 'YYYY-MM-DD')
                      return false
                    }
                  }
                )
                return this.ajaxUserError == null
              },
              /**
               *  Сохраняет выбранное время достави в сессию
               * @param date
               */
              pSaveSelectedTime (date) {
                try {
                  axios.request(
                    {
                      url: '/ajax/scheduleCartDeliverySaver.php',
                      method: 'post',
                      params: {
                        'data': this.deliveryTimeSelected[date],
                        'date': date,
                        'action': 'saveTime'
                      },
                      headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    }
                  )
                } catch (e) {
                  console.log(e)
                }
              },
              /**
               *  Сохраняет выбранный адрес доставки в сессии
               * @param {string} date
               */
              pSaveSelectedLocation (date) {
                try {
                  axios.request(
                    {
                      url: '/ajax/scheduleCartDeliverySaver.php',
                      method: 'post',
                      params: {
                        'data': this.deliveryLocation[date],
                        'date': date,
                        'action': 'saveAddress'
                      },
                      headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    }
                  )
                } catch (e) {
                  console.log(e)
                }
              },
              /**
               *  Открывает первый шаг с первичным вводом доставки
               */
              $openPaneAddress () {
                if (!this.semaphoreOrderSended) {
                  this.showPanelCheckout = false
                  this.showPanelSchedule = false
                  this.showPanelAddress = true
                  if (!this.showPickUpPane && !this.tDeliveryEditNow){
                    this.$setDeliveryBuffer(this.showingDate,true);
                  }
                }
              },
              /**
               * Открывает второй шаг с расписанием, если оно есть
               */
              $openPaneSchedule () {
                console.warn('try open schedule')
                if (Object.keys(this.days).length > 1 && !this.semaphoreFirstEntry) {
                  this.yandexReachGoal('checkout-open-schedule')
                  this.semaphoreFirstEntry = false
                  this.showPanelCheckout = false
                  this.showPanelAddress = false
                  this.showPanelSchedule = true
                }
              },
              onScheduleChange () {
                this.semaphoreFirstEntry = false
                this.$openPaneSchedule()
              },
              /**
               *  Открывает третий шаг с оформлением заказа
               */
              $openPaneCheckOut () {
                console.warn('try open check out')
                if (this.semaphoreCanCheckOut) {
                  this.showPanelCheckout = true
                  this.showPanelSchedule = false
                  this.showPanelAddress = false
                }

              },
              $updateDeliveryModalState () {
                if (!this.showAddressModal) {
                  console.log('showAddressModal set true')
                  this.showAddressModal = true
                } else {
                  console.log('call $forceUpdate')
                  this.$forceUpdate()
                }
              },

              $isFirstStage () {
                return this.showPanelAddress === true
              },
              $isFinalStage () {
                return this.showPanelCheckout === true
              },
              /**
               *  Перерисовывает первую панель, если пользователь вручную на нее переходит
               * @param {string} date
               */
              $resolveAddressPanelState (date) {
                console.log('resolve panel state')
                if (this.$isPickUpAddress(date)) {
                  console.log('attempt to resolve state: pickup reloaded')
                  this.tDeliveryEditNow = true
                  this.showPickUpPane = true
                } else {
                  if (this.$isCompleteAddress(date)) {
                    console.log('attempt to resolve state: full editor loaded')
                    this.tDeliveryEditNow = false
                    this.showPickUpPane = false
                    this.$setAddressAdditional();

                  } else {
                    console.log('attempt to resolve state: street editor loaded')
                    this.showPickUpPane = false
                    this.tDeliveryEditNow = true
                    this.$purgeDeliveryBuffer(true)
                  }
                }
                console.log('$resolveAddressPaneState force update')
                this.$forceUpdate()
              },
              /**
               *  Возвращает флаг принадлежности к компании
               * @returns {boolean}
               */
              hasCompany () {
                console.log(typeof this.company)
                return Boolean(Object.keys(this.company).length)
              },
              /**
               *  Возвращает флаг возожности заказа на текущую дату
               * @returns {boolean}
               */
              setChange (index, value = null) {
                if (value == null) {
                  this.changeSelected = this.changesList[index]
                } else {
                  this.changeSelected = value
                }

                this.$tClosePanelChanges()
              },
              setPaymentType (index) {
                this.paymentSelected = index
                this.$tClosePanelPayment()
              },
              $tAddCutlery (type) {
                this.cutlerySelected[type] += 1
              },
              $tRemoveCutlery (type) {
                this.cutlerySelected[type] -= 1
              },

              submit (event) {
                if (!this.$isWorkingTime()){
                  this.showWorkingTimeAttentionModal = true;
                  return false;
                }
                event.target.style.display = 'none'
                this.$v.$touch()
                if (!this.$v.$invalid) {
                  this.loader = true
                  this.checkRules(() => {

                    let iikoStatusInterval = null
                    let orderDeliveries = this.prepareAddressData()
                    this.loader = true
                    let order = {
                      'ADDRESS': orderDeliveries[0],
                      'ORDER_DELIVERIES': orderDeliveries,
                      'COL_PERSONS': 1,
                      'CHANGE': this.changeSelected,
                      'COMMENT': this.orderComment,
                      'MAIL': this.email,
                      'PHONE': this.phoneNumber,
                      'NAME': this.firstname,
                      'ROISTAT_ID': this.roistatID,
                      'CONFIRMED': 'Y',
                      'payment_type': this.paymentList[this.paymentSelected]['NAME'],
                      'payment_id': this.paymentSelected,
                      'NUMBER_OF_CUTLERY': parseInt(this.cutlerySelected.spoons) + parseInt(this.cutlerySelected.knives) + parseInt(this.cutlerySelected.forks),
                      'NUMBER_OF_CUTLERY_FORKS': this.cutlerySelected.forks,
                      'NUMBER_OF_CUTLERY_SPOONS': this.cutlerySelected.spoons,
                      'NUMBER_OF_CUTLERY_KNIVES': this.cutlerySelected.knives,
                    }

                    this.semaphoreOrderSended = true
                    this.semaphoreFirstEntry = true

                    $.ajax({
                      type: 'post',
                      url: this.actionURL,
                      data: order,
                      dataType: 'json',
                      success: function (data) {
                        if (data.status == 'success') {
                          try {
                            if (dataLayer !== undefined) {
                              dataLayer.push({ 'event': 'formsend' })
                            }
                          } catch (e) {
                          }
                          let orderID = data.data[0]['orderId']

                          clearTimeout(this.serviceLoaderTimeout)

                          /**  редирект таймер, если айко долго будет грузить статус */
                          this.serviceLoaderTimeout = setInterval(() => {
                            if (window.reachMetricsGoal !== undefined
                              && typeof (window.reachMetricsGoal) === typeof (Function)) {
                              window.reachMetricsGoal('checkout-iiko-timeout')
                            }
                            window.location.href = '/personal/order-result/?ORDER_ID=' + orderID
                          }, 120000)

                          /** ждем пока айко не пришлет номер заказа или расходной*/
                          iikoStatusInterval = setInterval(() => {
                            axios.request(
                              {
                                url: '/ajax/getOrderState.php',
                                method: 'get',
                                params: {
                                  orderId: orderID,
                                },
                                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                              }
                            ).then((response) => {
                              let state = response.data[0]
                              if (state['iikoCode'] !== null || state['outgoingNumber'] !== null) {
                                window.location.href = '/personal/order-result/?ORDER_ID=' + orderID
                              }
                            })
                          }, 2500)
                        }
                      },
                    })

                  })
                }

              },

              prepareAddressData () {
                let result = []
                Object.entries(this.deliveryLocation).forEach(([date, address]) => {
                  let dayRes = {}
                  let GUID = address['LOCATION']['terminal_id'];
                  dayRes['delivery_id'] = address['SELF_PICKUP'] == '1' ? DELIVERY_TYPE_PICKUP : DELIVERY_TYPE_DELIVERY
                  dayRes['value'] = this.createAddressString(address['ADDRESS'])
                  dayRes['flat'] = address['ADDRESS']['flat']
                  dayRes['floor'] = address['ADDRESS']['floor']
                  dayRes['entry'] = address['ADDRESS']['entry']
                  dayRes['housing'] = address['ADDRESS']['housing']
                  dayRes['house'] = address['ADDRESS']['house']
                  dayRes['street'] = address['ADDRESS']['street']
                  dayRes['address_comment'] = address['ADDRESS']['comment']
                  dayRes['terminal_guid'] = GUID
                  dayRes['deliveryTime'] = this.deliveryTimeSelected[date][GUID]
                  result.push(dayRes)
                })
                return result
              },

              /**
               *  Актуализирует список онлайн оплат относительно филиалов
               * @return {boolean}
               */
              rebuildPaymentsList () {

                if (!Object.values(this.merchantDelivery).length) {
                  console.error('Нет списка соответствий оплат')
                  return false
                }
                let locations = Object.values(this.deliveryLocation)
                let deliveryGUID = locations[0]['TERMINAL_ID'] ?? false
                let isEqual = true
                if (deliveryGUID) {
                  for (let i = 0; i < locations.length; i++) {
                    if (i !== 0) {
                      if (locations[i]['TERMINAL_ID'] !== deliveryGUID) {
                        isEqual = false
                        break
                      }
                    }
                  }
                }

                Object.entries(this.paymentRejected).forEach(([id, value]) => {
                  this.paymentList[id] = value
                })
                this.paymentRejected = {}

                if (isEqual) {
                  Object.entries(this.merchantDelivery).forEach(([paymentID, GUID]) => {
                    if (GUID !== deliveryGUID) {
                      this.paymentRejected[paymentID] = this.paymentList[paymentID]
                      delete this.paymentList[paymentID]
                    }
                  })
                } else {
                  Object.keys(this.merchantDelivery).forEach((id) => {
                    this.paymentRejected[id] = this.paymentList[id]
                    delete this.paymentList[id]
                  })
                }
                return true
              },

              yandexReachGoal (event) {
                if (window.reachMetricsGoal !== undefined
                  && typeof (window.reachMetricsGoal) === typeof (Function)) {
                  try {
                    window.reachMetricsGoal(event)
                  } catch (e) {
                    console.error(e)
                  }
                }
              },
              createAddressString (address) {

                let result = ''
                if (typeof address['street'] === 'string' && !address['street'].includes('Москва')) {
                  result = 'Москва, '
                }
                result = address['street']
                if (address['house']) {
                  result = result + ', д. ' + address['house']
                }
                if (address['housing']) {
                  result = result + ', к. ' + address['housing']
                }
                return result
              },
              $onFocusIn (e, a) {
                $(e.path[1]).addClass('focused')
              },

              $onFocusOut (e) {
                $(e.path[1]).removeClass('focused')
              },
              catalogRedirect () {
                window.location.href = '/catalog/'
              },
              canOrderToday () {
                if (!this.hasCompany()) {
                  return true
                }
                return !(!this.company['CAN_ORDER_TODAY'])
              },
            },
          }
        )
      }
    }
  )
})(jQuery)



